import * as Sentry from "@sentry/react";
import axios from "axios";

const SKIP_SENTRY_HEADER = 'x-gpsdv-skip-sentry';

export const initSentry = () => {
  Sentry.init({
    dsn: "https://fd69b841804411020b0c209379a858ba@o4507902306353152.ingest.us.sentry.io/4507930963607552",
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/app.gpsdataviz.com/],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,

    beforeSend(event, hint) {
      const error = hint.originalException;
      const response_headers = error?.response?.headers || {};
      if (response_headers[SKIP_SENTRY_HEADER]) {
        console.log("Skipping Sentry logging for error: ", error);
        return null;
      }

      return event;
    }

  });

  // intercept Axios errors and log as sentry errors
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {

      Sentry.withScope((scope) => {
        scope.setExtra("requestMethod", error.config?.method);
        scope.setExtra("requestUrl", error.config?.url);
        scope.setExtra("requestHeaders", error.config?.headers);
        scope.setExtra("requestParams", error.config?.params);
        scope.setExtra("requestBody", error.config?.data);
        scope.setExtra("responseStatus", error.config?.status_code);

        if (error.response) {
          scope.setTag('http.status_code', error.response.status);
          scope.setExtra('responseStatus', error.response.status);
          scope.setExtra('responseData', error.response.data);

        } else {
          scope.setTag('http.status_code', 'No Response');
        }

        scope.setTransactionName(error.config?.url || 'Unknown URL');

        // Capture the exception
        Sentry.captureException(error);
      });

      return Promise.reject(error);
    }
  )
}
